import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { uncutDetails } from '@/mocks/drama';

export default function UncutDetails() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="uncut" className="bg-secondary-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] lg:gap-16">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <SectionHeading
              eyebrow="Uncut details"
              title="未删减细节与完整版差别"
              desc="不同版本在时长与呈现上会有取舍，但人物的动机往往就藏在这些被简化的片段里。下面整理了五处最值得留意的内容。"
            />
            <div className="mt-6 rounded-lg border border-secondary-200 bg-background-50 p-5">
              <p className="text-sm leading-relaxed text-foreground-600">
                说明：以下为剧情层面的通用解析，用于帮助你理解不同版本之间的差异，具体呈现请以你观看或阅读的版本为准。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {uncutDetails.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.title}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-label font-bold text-primary-600">
                        {index + 1}
                      </span>
                      <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                        {item.title}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-xl text-secondary-500 transition-transform duration-300 ${
                        isOpen ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                      }`}
                    ></i>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">
                        {item.content}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}